import React, { Component } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import Breadcrumb from "../../common/breadcrumb";
import {
  loadUserDetailsFromLocalStorage,
  getValueFromLanguageObject,
} from "../../../store";
import { isOpenStoreIdExist } from "../../../utils/utils";
import {
  checkAuthAndRedirect,
  getCurrentPath,
} from "../../../utils/cartRedirect";

class AddressBook extends Component {
  state = {
    isLoading: true,
    billingAddresses: [],
    shippingAddresses: [],
  };

  componentDidMount() {
    const currentPath = getCurrentPath(this.props);
    if (!checkAuthAndRedirect(this.props, currentPath)) return;

    // Fetch addresses from localStorage
    const userDetails = loadUserDetailsFromLocalStorage();
    const billingAddresses =
      JSON.parse(userDetails.billingaddress) || [];
    const shippingAddresses =
      JSON.parse(userDetails.shippingaddress) || [];

    // Only keep addresses with type "shipping" for shippingAddresses
    const filteredShipping = shippingAddresses.filter(
      (addr) => addr.type === "shipping"
    );

    this.setState({
      isLoading: false,
      billingAddresses,
      shippingAddresses: filteredShipping,
    });
  }

  renderAddressCard = (address) => (
    <div key={address.id} className="col-md-6 col-lg-4 mb-4">
      <div className="card h-100">
        <div className="card-body p-4">
          <div className="d-flex justify-content-between align-items-start mb-3">
            <h5 className="card-title mb-0" style={{ fontWeight: 600 }}>
              {address.name}
            </h5>
            {address.isdefault && (
              <span
                className="badge badge-primary"
                style={{
                  fontSize: "13px",
                  padding: "4px 10px",
                  borderRadius: "8px",
                }}
              >
                {getValueFromLanguageObject("str_default") || "Default"}
              </span>
            )}
          </div>
          <div className="row">
            <div
              className="col-md-6 d-flex flex-column"
              style={{ gap: "6px" }}
            >
              <p className="card-text mb-2">
                <i
                  className="fa fa-phone mr-2 text-muted"
                  style={{ fontSize: "14px" }}
                ></i>
                {address.phone}
              </p>
              <p className="card-text mb-2">
                <i
                  className="fa fa-map-marker mr-2 text-muted"
                  style={{ fontSize: "14px" }}
                ></i>
                {address.addressline1}
              </p>
              <p className="card-text mb-2">
                <i
                  className="fa fa-home mr-2 text-muted"
                  style={{ fontSize: "14px" }}
                ></i>
                {address.addressline2}
              </p>
            </div>
            <div
              className="col-md-6 d-flex flex-column"
              style={{ gap: "6px" }}
            >
              <p className="card-text mb-2">
                <i
                  className="fa fa-building mr-2 text-muted"
                  style={{ fontSize: "14px" }}
                ></i>
                {address.city} {address.zipcode}
              </p>
              <p className="card-text mb-2">
                <i
                  className="fa fa-globe mr-2 text-muted"
                  style={{ fontSize: "14px" }}
                ></i>
                {address.state}
              </p>
              <p className="card-text mb-2">
                <i
                  className="fa fa-flag mr-2 text-muted"
                  style={{ fontSize: "14px" }}
                ></i>
                {address.country}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );

  render() {
    const { billingAddresses, shippingAddresses, isLoading } = this.state;

    if (isLoading) {
      return (
        <div className="text-center py-5">
          {getValueFromLanguageObject("str_loading") || "Loading..."}
        </div>
      );
    }

    return (
      <div style={{ minHeight: "calc(100vh - 220px)" }}>
        <Breadcrumb
          title={getValueFromLanguageObject("str_address_book") || "Address Book"}
        />
        <section className="section-b-space">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-12">
                <div className="d-flex justify-content-between align-items-center mb-4">
                  <h3>
                    {getValueFromLanguageObject("str_my_addresses") || "My Addresses"}
                  </h3>
                </div>
                {/* Billing Addresses */}
                <h5 className="mb-3">
                  {getValueFromLanguageObject("str_billing_address") ||
                    "Billing Address"}
                </h5>
                {billingAddresses.length === 0 ? (
                  <div className="text-center py-3">
                    <i className="fa fa-address-book fa-2x text-muted mb-2"></i>
                    <div>
                      {getValueFromLanguageObject("str_no_billing_addresses_found") ||
                        "No billing addresses found"}
                    </div>
                  </div>
                ) : (
                  <div className="row">
                    {billingAddresses.map(this.renderAddressCard)}
                  </div>
                )}

                {/* Shipping Addresses */}
                <h5 className="mb-3 mt-4">
                  {getValueFromLanguageObject("str_shipping_address") ||
                    "Shipping Address"}
                </h5>
                {shippingAddresses.length === 0 ? (
                  <div className="text-center py-3">
                    <i className="fa fa-address-book fa-2x text-muted mb-2"></i>
                    <div>
                      {getValueFromLanguageObject("str_no_shipping_addresses_found") ||
                        "No shipping addresses found"}
                    </div>
                  </div>
                ) : (
                  <div className="row">
                    {shippingAddresses.map(this.renderAddressCard)}
                  </div>
                )}
              </div>
            </div>
          </div>
        </section>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  // Add any state mappings if needed
});

export default connect(mapStateToProps, {})(AddressBook);
